// extracted by mini-css-extract-plugin
export default {"container":"UploadPDFSuccessModal_container__xK2w-","description":"UploadPDFSuccessModal_description__Rz+4B"};